import { queryClient, QUERY_CACHE_STORAGE_KEY } from "@/queryClient";

// The refresh token is an httpOnly cookie the API sets on log in and refresh
// (Review 2.6), so script here never sees it. Only the short-lived access
// token is held, in memory.
const accessToken = ref<string | undefined>();
const setAccessToken = (newToken: string) => {
  accessToken.value = newToken;
};

const isLoggedIn = computed(() => !!accessToken.value);

const logOut = () => {
  accessToken.value = undefined;
  // Drop the refresh cookie. A plain fetch: api.ts depends on this module.
  void fetch(`${__API_ROOT__}/auth/logout/`, {
    method: "POST",
    credentials: "same-origin",
  }).catch(() => undefined);
  // Don't leave cached booking data (incl. member names) in storage after
  // sign-out.
  queryClient.clear();
  window.sessionStorage.removeItem(QUERY_CACHE_STORAGE_KEY);
};

export const useAuth = () => {
  return {
    accessToken,
    setAccessToken,
    logOut,
    isLoggedIn,
  };
};
